import { useState, useEffect, useCallback, useLayoutEffect } from 'react'
import { useParams } from 'react-router'
import useRouter from 'utils/useRouter'
import { useFormState } from 'hooks/useFormState'
import { useUsuarioService } from 'hooks/useUsuarioService'
import { useVestigioService } from 'hooks/useVestigioService'
import { useAuth } from 'hooks/useAuth'

const schema = {
  lacre: {
    presence: { allowEmpty: false, message: '^Lacre é obrigatório' },
  },
  usuarioDestino: {
    presence: { allowEmpty: false, message: '^Usuário destino é obrigatório' },
  },
}

export const usePassarCustodia = () => {
  const router = useRouter()
  const params = useParams()
  const usuarioService = useUsuarioService()
  const vestigioService = useVestigioService()
  const { currentUser } = useAuth()

  const [usuarios, setUsuarios] = useState([])
  const [processandoUsuarios, setProcessandoUsuarios] = useState(false)
  const [vestigio, setVestigio] = useState(null)
  const [processandoVestigio, setProcessandoVestigio] = useState(false)
  const [processandoOperacao, setProcessandoOperacao] = useState(false)
  const [isFormError, setIsFormError] = useState(false)

  const formPassagemCustodia = useFormState(schema)

  const fetchVestigio = useCallback(async () => {
    const response = await vestigioService.listarVestigioAsync(params.id, setProcessandoVestigio)
    setVestigio(response)
  }, [params.id])

  const fetchUsuariosDoSetor = useCallback(async () => {
    if (vestigio?.id_setor_atual) {
      const list = await usuarioService.listarUsuariosDeSetorAsync(vestigio.id_setor_atual, setProcessandoUsuarios)
      setUsuarios(list.filter((usu) => usu.id !== currentUser.id))
    }
  }, [vestigio, currentUser.id])

  const handleSolicitarPassagemCustodia = async () => {
    await vestigioService.solicitarPassagemCustodia(vestigio.id, formPassagemCustodia.formState.values, setProcessandoOperacao)
    router.history.push(`/casos/caso/vestigio/detalhar/${params.id}`)
  }

  useEffect(() => {
    if (formPassagemCustodia.hasErrorWithoutTouch('lacre') || formPassagemCustodia.hasErrorWithoutTouch('usuarioDestino')) {
      setIsFormError(true)
    } else {
      setIsFormError(false)
    }
  }, [formPassagemCustodia])

  useEffect(() => {
    fetchVestigio()
  }, [fetchVestigio])

  useEffect(() => {
    fetchUsuariosDoSetor()
  }, [fetchUsuariosDoSetor])

  useLayoutEffect(() => {
    if (vestigio?.id) {
      formPassagemCustodia.setFormState((prevState) => ({
        ...prevState,
        values: {
          ...prevState.values,
          lacre: vestigio.lacre,
          tipoEmbalagem: vestigio.tipoEmbalagem,
          outroTipoEmbalagem: vestigio.outroTipoEmbalagem,
        },
      }))
    }
  }, [vestigio])

  return {
    formPassagemCustodia,
    usuarios,
    processandoUsuarios,
    vestigio,
    processandoVestigio,
    processandoOperacao,
    isFormError,
    handleSolicitarPassagemCustodia,
    router,
    params,
  }
}
